import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { Icon, BtnUi, PreferencesNoticeUi } from "~/components";
import { BrightcoveVideoContainer } from "../VideoContainer";
import { useLayoutStore } from "~/store";
import styles from "./Survey.module.css";
import logoImage from "~/assets/images/marriott-logo-reverse.png";

export const Survey = ({ data, next, hasDelay = true }) => {
  const { isResetting, setShowHeader, setContentClassName } = useLayoutStore();
  const { passionName, iconName, videoId } = data;

  useEffect(() => {
    if (isResetting) {
      return;
    }

    setShowHeader(false);
    setContentClassName(styles.container);
  }, [isResetting]);

  const [inProgress, setInProgress] = useState(false);
  const [yesActive, setYesActive] = useState(false);
  const [noActive, setNoActive] = useState(false);
  const delayedNext = async (action) => {
    if (inProgress) {
      return;
    }

    setInProgress(true);

    // Skip button
    if (action === null) {
      next(action);
      setInProgress(false);
      return;
    }

    // Set active
    action ? setYesActive(true) : setNoActive(true);

    const delay = hasDelay ? 3000 : 500;
    await new Promise((res) => setTimeout(res, delay));

    // Reset
    setYesActive(false);
    setNoActive(false);

    next(action);
    setInProgress(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.survey}>
        <div className={styles.surveyLogoWrapper}>
          <img
            className={styles.surveyLogo}
            src={logoImage}
            alt="Marriott logo"
          />
        </div>
        <section className={styles.surveyBox}>
          <BrightcoveVideoContainer
            className={styles.surveyVideo}
            videoId={videoId}
          />
          <div className={styles.surveyInfo}>
            <Icon name={iconName} className={styles.surveyIcon} />
            <div className={styles.surveyText}>I’m passionate about...</div>
            <div className={styles.surveyPassion}>{passionName}</div>
            <div className={styles.surveyBtnGroup}>
              <BtnUi
                className={classNames(styles.surveyBtn, "custom_click_track", {
                  [styles.surveyBtnNo]: noActive,
                })}
                data-custom_click_track_value={`Video|${passionName}-thumbs down|internal`}
                onClick={delayedNext.bind(null, false)}
              >
                <span>No</span>
                <Icon name="dislike" className={styles.surveyBtnIcon} />
              </BtnUi>
              <BtnUi
                className={classNames(styles.surveyBtn, "custom_click_track", {
                  [styles.surveyBtnYes]: yesActive,
                })}
                data-custom_click_track_value={`Video|${passionName}-thumbs up|internal`}
                onClick={delayedNext.bind(null, true)}
              >
                <span>Yes</span>
                <Icon name="like" className={styles.surveyBtnIcon} />
              </BtnUi>
            </div>
            <BtnUi
              className={classNames(styles.surveySkip, "custom_click_track")}
              data-custom_click_track_value={`Video|${passionName}-skip|internal`}
              onClick={delayedNext.bind(null, null)}
            >
              <span>Skip</span>
              <Icon name="arrowRight" className={styles.surveySkipIcon} />
            </BtnUi>
          </div>
        </section>
      </div>
      <PreferencesNoticeUi className={styles.notice} />
    </div>
  );
};
